import { Category, IRogue } from '@/js/services/RogueTypes'

type LinkType = {
  name: string,
  id?: number,
  link: string,
  image?: string,
  desc?: string,
  label?: string,
  show?: string[],
  filter?: {[key: string]: string},
  active?: boolean,
  directLink?: string
}
interface CategoryLinks {
  type: string,
  links: LinkType[],
}
export const LINKS: {[key: string]: CategoryLinks} = {
  // Weightlifting
  4667: {
    links: [
      { name: 'Bars', id: 4669, link: '/weightlifting-bars-plates/barbells' },
      { name: 'Plates', id: 4681, link: '/weightlifting-bars-plates/bumpers' },
      { name: 'Storage', id: 4691, link: '/weightlifting-bars-plates/bar-plate-storage' },
      { name: 'Collars', id: 4703, link: '/weightlifting-bars-plates/collars' },
    ],
    type: 'text',
  },
  4703: {
    links : [],
    type  : 'empty',
  },
  // Bodyweight & Gymnastics
  5001: {
    links: [
      { name: 'Rings', id: 5005, link: '/bodyweight-gymnastics/gymnastics/rings' },
      { name: 'Pull-up Systems', id: 5023, link: '/bodyweight-gymnastics/rpg-pullup-system' },
      { name: 'Ropes', id: 5035, link: '/bodyweight-gymnastics/ropes' },
      { name: 'Grip', id: 5043, link: '/bodyweight-gymnastics/grip' },
    ],
    type: 'text',
  },
  // Barbells
  4669: {
    links: [
      { name: 'Mens', id: 4671, link: '/weightlifting-bars-plates/barbells/mens-20kg-barbells' },
      { name: 'Womens', id: 4673, link: '/weightlifting-bars-plates/barbells/womens-15kg-barbells' },
      { name: 'Juniors', id: 4675, link: '/weightlifting-bars-plates/barbells/junior-barbells' },
      { name: 'Technique', id: 4677, link: '/weightlifting-bars-plates/barbells/technique-barbells' },
      { name: 'Specialty', id: 4679, link: '/weightlifting-bars-plates/barbells/specialty-barbells' },
      { name: 'Athlete', id: 13762, link: '/weightlifting-bars-plates/barbells/athlete-barbells', show: ['USA', 'APO', 'CAN'] },
      { name: 'Boneyard Bars', link: '/deals?deal_type=rogue_boneyard&category=Weightlifting%20Bars%20%26%20Plates', show: ['USA'] },
      { name: 'Custom', id: 13902, link: '/weightlifting-bars-plates/barbells/custom-barbells', show: ['USA'] },
    ],
    type: 'text',
  },
  // Bar Components
  14109: {
    links: [
      { name: 'Ohio Bar', id: 14111, link: '/weightlifting-bars-plates/barbells/barbell-components/ohio-bar' },
      { name: 'Bella Bar', id: 14113, link: '/weightlifting-bars-plates/barbells/barbell-components/bella-bar' },
    ],
    type: 'text',
  },
  // Plates
  4681: {
    links: [
      { name: 'Bumper', id: 4683, link: '/weightlifting-bars-plates/bumpers/bumper-plates' },
      { name: 'Competition', id: 4685, link: '/weightlifting-bars-plates/bumpers/competition-bumpers' },
      { name: 'Steel', id: 4687, link: '/weightlifting-bars-plates/bumpers/steel-plates' },
      { name: 'Change Plates', id: 4689, link: '/weightlifting-bars-plates/bumpers/change-plates' },
    ],
    type: 'text',
  },
  // Rigs Racks
  7967: {
    links: [
      { name: 'Power Racks', id: 8183, link: '/rogue-rigs-racks/power-racks', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Power-Rack-RigsRack-PG_bllhau.png', label: 'Power Racks' },
      { name: 'Squat Stands', id: 8173, link: '/rogue-rigs-racks/squat-stands', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Squat-Stand-RigsRack-PG_wacmfe.png', label: 'Squat Stands' },
      { name: 'Rigs', id: 8193, link: '/rogue-rigs-racks/rigs', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Rig-RigsRack-PG_murixi.png', show: ['USA', 'CAN', 'EUR', 'AUS', 'GBR'], label: 'Rigs' },
      { name: 'Wallmounts', id: 8203, link: '/rogue-rigs-racks/wallmounts', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Wallmount-RigsRack-PG_ogzpoa.png', label: 'Wallmounts' },
      { name: 'Accessories', id: 8213, link: '/rogue-rigs-racks/accessories', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Accessories-RigsRack-PG_s9e3pw.png', label: 'Accessories' },
    ],
    type: 'image',
  },
  // Power Racks
  8183: {
    links: [
      { name: 'RM43', id: 14159, link: '/rogue-rigs-racks/power-racks/rm-43-racks', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rack%20Category%20Assets/RM43-Upright-Rack-Steel-Config_max13e.png', desc: '4x3" Steel Tube<br>11 Gauge Steel<br>1" Hardware', show: ['USA', 'CAN'], label: 'RM43' },
      { name: 'Monster', filter: { cat3: 'Monster Racks' }, id: 8185, link: '/rogue-rigs-racks/power-racks?cat3=Monster%20Racks', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rack%20Category%20Assets/Monster-Upright-Steel-Config_yu0mvf.png', desc: '3x3" Steel Tube<br>11 Gauge Steel<br>1" Hardware', show: ['USA', 'CAN', 'EUR', 'AUS', 'GBR'], label: 'Monster' },
      { name: 'Monster Lite', filter: { cat3: 'Monster Lite Racks' }, id: 8187, link: '/rogue-rigs-racks/power-racks?cat3=Monster%20Lite%20Racks', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rack%20Category%20Assets/MonsterLite-Upright-Steel-Config_kbgnqv.png', desc: '3x3" Steel Tube<br>11 Gauge Steel<br>5/8" Hardware', label: 'Monster Lite' },
      { name: 'Infinity', filter: { cat3: 'Infinity Series Racks' }, id: 8189, link: '/rogue-rigs-racks/power-racks?cat3=Infinity%20Series%20Racks', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rack%20Category%20Assets/Infinity-Upright-Steel-Config_ymtyp6.png', desc: '2x3" Steel Tube<br>11 Gauge Steel<br>5/8" Hardware', show: ['USA', 'CAN', 'APO', 'EUR', 'GBR'], label: 'Infinity' },
    ],
    type: 'image',
  },
  // Equipment Packages
  4863: {
    links: [
      { name: 'CrossFit® Packages', id: 4865, link: '/equipment-packages/crossfit-packages' },
      { name: 'Affiliate Packages', id: 4881, link: '/equipment-packages/affliate' },
      { name: 'Garage Gym', id: 4899, link: '/equipment-packages/personal-packages' },
      { name: 'Military Packages', id: 4915, link: '/equipment-packages/military-packages' },
    ],
    type: 'text',
  },
  // Apparel
  5091: {
    links: [
      { name: 'New Arrivals', link: '/gear-apparel/new-arrivals' },
      { name: 'Classics', id: 9773, link: '/gear-apparel/classics' },
      { name: 'T-Shirts', id: 5139, link: '/gear-apparel/t-shirts' },
      { name: 'Sweatshirts', id: 5141, link: '/gear-apparel/sweatshirts' },
      { name: 'Shorts', id: 5143, link: '/gear-apparel/shorts' },
      { name: 'Hats', id: 5123, link: '/gear-apparel/headwear/hats' },
      { name: 'Socks', id: 5131, link: '/gear-apparel/accessories/socks' },
      { name: 'Athlete Shirts', id: 7709, link: '/gear-apparel/athlete-shirts' },
      { name: 'Deals', link: '/deals?category=Apparel' },
    ],
    type: 'text',
  },
  // Headwear
  5121: {
    links: [
      { name: 'New Arrivals', link: '/gear-apparel/new-arrivals' },
      { name: 'Classics', id: 9773, link: '/gear-apparel/classics' },
      { name: 'T-Shirts', id: 5139, link: '/gear-apparel/t-shirts' },
      { name: 'Sweatshirts', id: 5141, link: '/gear-apparel/sweatshirts' },
      { name: 'Shorts', id: 5143, link: '/gear-apparel/shorts' },
      { name: 'Hats', id: 5123, link: '/gear-apparel/headwear/hats' },
      { name: 'Socks', id: 5131, link: '/gear-apparel/accessories/socks' },
      { name: 'Athlete Shirts', id: 7709, link: '/gear-apparel/athlete-shirts' },
      { name: 'Deals', link: '/deals?category=Apparel' },
    ],
    type: 'text',
  },
  // Accessories
  5129: {
    links: [
      { name: 'New Arrivals', link: '/gear-apparel/new-arrivals' },
      { name: 'Classics', id: 9773, link: '/gear-apparel/classics' },
      { name: 'T-Shirts', id: 5139, link: '/gear-apparel/t-shirts' },
      { name: 'Sweatshirts', id: 5141, link: '/gear-apparel/sweatshirts' },
      { name: 'Shorts', id: 5143, link: '/gear-apparel/shorts' },
      { name: 'Hats', id: 5123, link: '/gear-apparel/headwear/hats' },
      { name: 'Socks', id: 5131, link: '/gear-apparel/accessories/socks' },
      { name: 'Athlete Shirts', id: 7709, link: '/gear-apparel/athlete-shirts' },
      { name: 'Deals', link: '/deals?category=Apparel' },
    ],
    type: 'text',
  },
  // Shoes
  5063: {
    links: [
      { name: 'Weightlifting Shoes', id: 5065, link: '/shoes/weightlifting-shoes' },
      { name: 'CrossFit® Shoes', id: 5077, link: '/shoes/crossfit-shoes' },
      { name: 'Training Shoes', id: 5085, link: '/shoes/training-shoes' },
      { name: 'Deals', link: '/deals?category=Shoes' },
    ],
    type: 'text',
  },
  // Weightlifting Shoes
  5065: {
    links: [
      { name: 'Weightlifting Shoes', id: 5065, link: '/shoes/weightlifting-shoes' },
      { name: 'CrossFit® Shoes', id: 5077, link: '/shoes/crossfit-shoes' },
      { name: 'Training Shoes', id: 5085, link: '/shoes/training-shoes' },
      { name: 'Deals', link: '/deals?category=Shoes' },
    ],
    type: 'text',
  },
  // Crossfit Shoes
  5077: {
    links: [
      { name: 'Weightlifting Shoes', id: 5065, link: '/shoes/weightlifting-shoes' },
      { name: 'CrossFit® Shoes', id: 5077, link: '/shoes/crossfit-shoes' },
      { name: 'Training Shoes', id: 5085, link: '/shoes/training-shoes' },
      { name: 'Deals', link: '/deals?category=Shoes' },
    ],
    type: 'text',
  },
  // Training Shoes
  5085: {
    links: [
      { name: 'Weightlifting Shoes', id: 5065, link: '/shoes/weightlifting-shoes' },
      { name: 'CrossFit® Shoes', id: 5077, link: '/shoes/crossfit-shoes' },
      { name: 'Training Shoes', id: 5085, link: '/shoes/training-shoes' },
      { name: 'Deals', link: '/deals?category=Shoes' },
    ],
    type: 'text',
  },
  // Straps, Wraps, & Support
  5191: {
    links: [
      { name: 'Straps & Wraps', id: 5193, link: '/lifting-straps-wraps/straps-wraps' },
      { name: 'Hand Protection', id: 5201, link: '/lifting-straps-wraps/hand-protection' },
      { name: 'Belts', id: 5209, link: '/lifting-straps-wraps/lifting-belts' },
      { name: 'Protection & Supports', id: 5215, link: '/lifting-straps-wraps/protection-supports' },
      { name: 'Weight Straps', id: 5221, link: '/lifting-straps-wraps/weight-straps' },
    ],
    type: 'text',
  },
  // Strongman
  5229: {
    links: [
      { name: 'Yokes & Sleds', id: 5231, link: '/strongman/sleds' },
      { name: 'Logs & Axles', id: 5241, link: '/strongman/logs-axles-handles' },
      { name: 'Sandbags & Stone Molds', id: 5249, link: '/strongman/sandbags-stone-molds' },
      { name: 'Grip Strength', id: 5259, link: '/strongman/hammers-grip' },
      { name: 'Accessories', id: 5279, link: '/strongman/accessories' },
    ],
    type: 'text',
  },
  // Mobility
  6005: {
    links: [
      { name: 'Bands', id: 6015, link: '/mobility-rehab/mobility-tools/bands' },
      { name: 'Tape', id: 6037, link: '/mobility-rehab/mobility-accessories/tape' },
      { name: 'Foam Rollers', id: 6013, link: '/mobility-rehab/mobility-tools/rollers' },
      { name: 'Balls', id: 6011, link: '/mobility-rehab/mobility-tools/balls' },
      { name: 'Mobility accessories', id: 6033, link: '/mobility-rehab/mobility-accessories' },
    ],
    type: 'text',
  },
  // Spring Gear
  7975: {
    links: [
      { name: 'T-Shirts', id: 5139, link: '/gear-apparel/t-shirts' },
      { name: 'Sweatshirts', id: 5141, link: '/gear-apparel/sweatshirts' },
      { name: 'Shorts', id: 5143, link: '/gear-apparel/shorts' },
      { name: 'Hats', id: 5123, link: '/gear-apparel/headwear/hats' },
      { name: 'Socks', id: 5131, link: '/gear-apparel/accessories/socks' },
      { name: 'Shoes', id: 5063, link: '/shoes' },
    ],
    type: 'text',
  },
  // Gift Guide
  8944: {
    links: [
      { name: 'Gifts for Him', id: 8945, link: '/gift-guide/mens' },
      { name: 'Gifts for Her', id: 8946, link: '/gift-guide/womens' },
      { name: 'Gifts for Kids', id: 8957, link: '/gift-guide/kids' },
      { name: 'Stocking Stuffers', id: 8956, link: '/gift-guide/stocking-stuffers' },
      { name: 'Under $30', id: 9042, link: '/gift-guide/stocking-stuffers/under-30', show: ['USA', 'APO'] },
      { name: 'Under $60', id: 9044, link: '/gift-guide/stocking-stuffers/under-60', show: ['USA', 'APO'] },
      { name: 'Under $50', id: 9042, link: '/gift-guide/stocking-stuffers/under-50', show: ['CAN'] },
      { name: 'Under $40', id: 9042, link: '/gift-guide/stocking-stuffers/under-40', show: ['EUR', 'AUS', 'GBR'] },
      { name: 'Under $80', id: 9044, link: '/gift-guide/stocking-stuffers/under-80', show: ['EUR', 'AUS', 'CAN', 'GBR'] },
    ],
    type: 'text',
  },
  // Replacement Parts
  14632: {
    links: [
      { name: 'Echo Bike', label: 'Echo Bike', id: 14647, link: '/replacement-parts/echo-bike', image: '/catalog/Conditioning/Endurance%20/Bikes/ECHOBIKE/ECHOBIKE-TH_ih5rzy_vrwbpt.png' },
      { name: 'Echo Rower', label: 'Echo Rower', id: 14648, link: '/replacement-parts/echo-rower', image: '/catalog/Conditioning/Endurance%20/Echo%20Rower/Rogue-Rower-TH_2_qk9rz5_nqdwzp.png' },
      { name: 'Echo SKI', label: 'Echo SKI', id: 14764, link: '/replacement-parts/echo-ski', image: '/catalog/Conditioning/Endurance%20/SkiErgs/IP0944/Rogue-Ski-Erg_1_z3xivk.png' },
      // { name: 'Cable Machines', label: 'Cable Machines', id: 14640, link: '/replacement-parts/cable-machines', image: '/catalog/Rigs%20and%20Racks/Rig%20and%20Rack%20Category%20Landing%20page%20/Rig%20and%20Rack%20Category%20Assets/Functional-Trainer-Red_zcupyf.png' },
      { name: 'Barbells', label: 'Barbells', id: 14633, link: '/replacement-parts/barbells', image: '/catalog/Weightlifting%20Bars%20and%20Plates/Barbells/Mens%2020KG%20Barbells/OHIOCERAKOTE/OHIOCERAKOTE-TH_izat7z_zjbvnb.png' },
      { name: 'Rig & Rack Parts', label: 'Rig & Rack Parts', id: 14655, link: '/replacement-parts/rig-and-rack-parts', image: '/catalog/Rigs%20and%20Racks/Power%20Racks%20/Monster%20Lite%20Racks/RF0863-2035C/RF0863-2035C-MG-TH_nb8nae_wjxi2m.png' },
    ],
    type: 'image',
  },
}

type RBBreadCrumb = {
  name: string,
  url: string,
  hide?: string[] | string
}

export function getTopLinks(data: Category, store: string, l10nPrefix = '', rogue:IRogue) {
  let links!: LinkType[] | string

  const currentCategory = LINKS[data.categoryId] || LINKS[data.path[data.path.length - 1]?.categoryId] || { type: '', links: [], filterKey: '', filterParentLink: '' }

  if (currentCategory.type === 'text') {
    links = (currentCategory.links)
      // Filter out the current category and any that aren't available on this site
      .filter(link => link.id !== data.categoryId && (!link.show || link.show.includes(store)))
      // Turn the json into HTML
      .map(cat => `<a data-track="Category Breadcrumbs" href="${l10nPrefix}${cat.link}" ${cat.id ? `categoryid="${cat.id}"` : ''}>${rogue.__(cat.name, 'auto')}</a>`)
      // Add the breadcrumb style separators
      .join('<div class="sep"></div>')
  } else if (currentCategory.type === 'image') {
    links = (currentCategory.links)
      // Filter out the current category and any that aren't available on this site
      .filter(link => ((link.filter || link.id !== data.categoryId) && (!link.show || link.show.includes(store))))
  }

  return { type: currentCategory.type, links }
}

export function getTopLinksFromRB(breadCrumbs: RBBreadCrumb[], rogue:IRogue): { type: string, links: string } {
  const links: string = breadCrumbs
    .filter(crumb => !crumb.hide || crumb.hide.indexOf(rogue.site.code) === -1)
    .map(bcrumb => `<a data-track="Category Breadcrumbs" href="${rogue.l10n.path || ''}${bcrumb.url}">${rogue.__(bcrumb.name, 'auto')}</a>`).join('<div class="sep"></div>')

  return { type: 'text', links }
}
